import { types, getSnapshot, applySnapshot } from 'mobx-state-tree'

import { AppConfigRoot } from './models/appConfig/root'
import { TournamentsRoot } from './models/entities/tournament/root'
import { EventsRoot } from './models/entities/event/root'
import { AthletesRoot } from './models/entities/athlete/root'
import { AdminAthletesRoot } from './models/entities/admin-athlete/root'
import { AdminSponsorsRoot } from './models/entities/admin-sponsors/root'
import { TeamsRoot } from './models/entities/team/root'
import { BeneficiariesRoot } from './models/member/beneficiary/root'
import { TriggersRoot } from './models/trigger/root'
import { AuthRoot } from './models/auth/root'
import { InWinsRoot } from './models/inwin/root'
import { BalanceRecordsRoot } from './models/balance/root'
import { AdminTeamsRoot } from './models/entities/admin-team/root'

export const createAppStore = (dependencies) => {
  const Store = types
    .compose(
      AppConfigRoot,
      AuthRoot,
      AthletesRoot,
      BalanceRecordsRoot,
      InWinsRoot,
      BeneficiariesRoot,
      EventsRoot,
      TeamsRoot,
      TriggersRoot,
      TournamentsRoot,
      AdminAthletesRoot,
      AdminTeamsRoot,
      AdminSponsorsRoot
    )
    .actions((self) => {
      let initialState = null

      return {
        afterCreate() {
          initialState = getSnapshot(self)
        },

        resetStore() {
          if (initialState) {
            applySnapshot(self, initialState)
          }
        },
      }
    })
    .views(() => ({
      get appVersion() {
        return VERSION
      },
    }))

  return Store.create({}, dependencies)
}
